<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
      <iframe src="https://www.cdc.gov/bmi/es/child-teen-calculator/calculator.html" title="Calculadora de percentil de IMC para ninos y adolescentes" height="680"></iframe>
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Layout, Footer
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
}
</script>